import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	statusLabel: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.status-filter.status-label',
		defaultMessage: 'Status',
		description:
			'Label shown on a filter dropdown indicating that the filter is used to filter Pull Requests by status',
	},
});
